import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "settings-export" }

import ExportPreference from 'vcomponents/settings/export/ExportPreference.vue';
import ExportHistory from 'vcomponents/settings/export/ExportHistory.vue';
import { computed } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'SettingsExportComponent',
  props: {
    settings: {
        type: Object,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const store = useStore();
const isAdmin = computed(() => store.state.user.isAdmin);
const isActiveHistory = computed(() => store.state.user.permissions?.acl?.view_exports);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isAdmin.value)
      ? (_openBlock(), _createBlock(ExportPreference, {
          key: 0,
          settings: props.settings
        }, null, 8 /* PROPS */, ["settings"]))
      : _createCommentVNode("v-if", true),
    (isActiveHistory.value)
      ? (_openBlock(), _createBlock(ExportHistory, { key: 1 }))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})